import i18next from 'i18next'
import {FC, useMemo} from 'react'
import {Col, Form, Row} from 'react-bootstrap'
import {useTranslation} from 'react-i18next'
import {useAppSelector} from 'src/redux/hooks'
import {soSelector} from 'src/redux/slices/soSlices'

interface Props {}

export const InputQuantumContractTolerance: FC<Props> = () => {
  const {t} = useTranslation()
  const {orderItem} = useAppSelector(soSelector)

  const quantumContract = useMemo(() => {
    return Number(orderItem?.order_sub_detail?.quantum_contract) ?? 0
  }, [orderItem])

  const productType = useMemo(() => {
    return orderItem?.order_sub_detail?.product_type ?? ''
  }, [orderItem])

  const shippingToleranceContract = useMemo(() => {
    return orderItem?.shipping_tolerance_contract ?? 0
  }, [orderItem])

  const sectorId = useMemo(() => {
    return orderItem?.sector_id ?? ''
  }, [orderItem])

  return (
    <Row className='mb-3'>
      <Col md={4}>
        <Form.Label className='mt-3' hidden={quantumContract <= 0 ? true : false}>
          {productType == '8105' ? t('sack') : t('CREATE_SO.ADD_SO_MODAL.QUANTUM_CONTRACT_LABEL')}
        </Form.Label>
      </Col>
      <Col md={8}>
        <Form.Control
          size='sm'
          aria-label='Default select example'
          hidden={quantumContract === 0 ? true : false}
          disabled
          defaultValue={
            isNaN(quantumContract)
              ? 0
              : (i18next.language === 'en'
                  ? quantumContract.toLocaleString('en', {
                      maximumFractionDigits: 4,
                    })
                  : quantumContract.toLocaleString('id', {
                      maximumFractionDigits: 4,
                    })) +
                (productType == '8105' ? ' EA' : sectorId === 3 ? ' MT' : ' Ton') +
                `(+/-${shippingToleranceContract}%)`
          }
        />
      </Col>
    </Row>
  )
}
